<template lang="pug">
linked-tabs(round)
  linked-tabs-item-round.tab-item(
    :to="localePath('arena')"
    :class="{'tab-item--active': isActive('arena') && !isActive('duel') }"
  )
    .tab-item__icon
      img(v-if="isActive('arena')" src="~/assets/images/icons/i_arena_TOP_on.png")
      img(v-else src="~/assets/images/icons/i_arena_TOP_off.png")
    span {{ $t('arena.menuTitle') }}
  linked-tabs-item-round.tab-item(
    :to="localePath('rankmatch')"
    :class="{'tab-item--active': isActive('rankmatch') }"
  )
    .tab-item__icon
      img(v-if="isActive('rankmatch')" src="~/assets/images/icons/i_quest_LAND_on.png")
      img(v-else src="~/assets/images/icons/i_quest_LAND_off.png")
    span {{ $t('rankMatch.title') }}
  linked-tabs-item-round.tab-item(
    :to="localePath('titlematch')"
    :class="{'tab-item--active': isActive('titlematch') }"
  )
    .tab-item__icon
      img(v-if="isActive('titlematch')" src="~/assets/images/icons/i_arena_TITLE_on.png")
      img(v-else src="~/assets/images/icons/i_arena_TITLE_off.png")
    span {{ $t('titleMatch.title') }}
  linked-tabs-item-round.tab-item(
    :class="{'tab-item--active': isActive('duel-arena') }"
    :to="localePath('duel-arena')"
  )
    .tab-item__icon
      img(v-if="isActive('duel-arena')" src="~/assets/images/icons/i_arena_USER_on.png")
      img(v-else src="~/assets/images/icons/i_arena_USER_off.png")
      .playerMatchCountArea(v-if="publicArenasCount > 0")
        .playerMatchCountArea--count
          span {{ publicArenasCount }}
    span {{ $t('battle.arena.title') }}
</template>

<script>
const LinkedTabs = () => import('@/components/organisms/LinkedTabs')
const LinkedTabsItemRound = () => import('@/components/molecules/LinkedTabsItemRound')

export default {
  components: { LinkedTabs, LinkedTabsItemRound },
  data: () => ({
    publicArenasCount: 0,
  }),
  computed: {
  },
  async beforeMount() {
    await this.getPublicArenas()
  },
  methods: {
    isActive(path) {
      return this.$route.name.includes(path)
    },
    async getPublicArenas() {
      const publicArenas = await this.$arenaService.getOngoingPublicArenaPasswords(0, 10000)
      this.publicArenasCount = publicArenas.passwordsList.length
    },
  },
}
</script>

<style lang="scss">
.tab-item {
  span {
    display: block;
    font-size: 0.7rem;
    color: rgba($color-swan, 0.7);
  }

  >a>svg {
    margin-left: 0.5rem;
    font-size: 1.3rem;

    @media (min-width: $breakpoint) {
      font-size: 1.6rem;
    }
  }

  &--active {
    span {
      font-weight: bold;
      color: $color-swan;
    }

    .tab-item__icon {
      background-color: #332511;
      border: 2px solid #0d0000;
    }
  }

  &__icon {
    @extend %col;
    margin: 0 auto 0.15rem;
    height: 2.5rem;
    width: 2.5rem;
    border-radius: 50%;
    background: #4a381c;
    border: 2px solid #332511;
    color: #d2b887;
    position: relative;
  }
}

.playerMatchCountArea {
  position: absolute;
  right: -5px;
  top: -5px;
  background: orange;
  border-radius: 50%;
  min-width: 1rem;
  height: 1rem;

  &--count {
    padding: 0.1rem;
    line-height: 1;
  }
}
</style>
